import { getUrlParamByName } from 'embed/utils'

const cohortA = require('./cohorts/cohort-a.json')
const cohortB = require('./cohorts/cohort-b.json')
const cohortC = require('./cohorts/cohort-c.json')
const cohortD = require('./cohorts/cohort-d.json')
const cohortE = require('./cohorts/cohort-e.json')

const companyUuidFromUrlParams = getUrlParamByName(document.location.search, 'company_uuid')

// Gets name of cohort our company UUID is in.
const getCohort = (companyUuid: string) => {
  let cohort
  cohortA.uuids.find((uuid) => (uuid === companyUuid ? (cohort = 'A') : null))
  cohortB.uuids.find((uuid) => (uuid === companyUuid ? (cohort = 'B') : null))
  cohortC.uuids.find((uuid) => (uuid === companyUuid ? (cohort = 'C') : null))
  cohortD.uuids.find((uuid) => (uuid === companyUuid ? (cohort = 'D') : null))
  cohortE.uuids.find((uuid) => (uuid === companyUuid ? (cohort = 'E') : null))
  return cohort
}

if (companyUuidFromUrlParams) {
  const selectedCohort = getCohort(companyUuidFromUrlParams.trim())
  if (selectedCohort) {
    window.dataLayer.push({ EVEN_COHORT: selectedCohort })
  }
}
